import copy from 'copy-to-clipboard'

export default function copyText(text: string): void {
  copy(text, {
    message: 'Нажмите #{key} для копирования',
  })
}
